import { useEffect } from 'react';
import { AccommodationsConsoleViewMode } from '../AccommodationsConsole.types';
import { useManagedSearchParam } from '@apps/admin/common/hooks/useManagedSearchParam';
import { ACCOMMODATIONS_CONSOLE_ROOT_QUERY_PARAM_KEY } from './useAccommodationsConsoleSearchParamsState';

/**
 * When in 'overlay' view mode, we want to clear out the related search params
 * whenever the overlay closes.
 */
export const useClearAccommodationConsoleSearchParamsOnUnmount = (viewMode: AccommodationsConsoleViewMode) => {
  const [, setAcsQueryParam] = useManagedSearchParam(ACCOMMODATIONS_CONSOLE_ROOT_QUERY_PARAM_KEY, undefined, 'push');
  const isInOverlay = viewMode === 'overlay';
  useEffect(() => {
    return () => {
      if (isInOverlay) {
        setAcsQueryParam(null);
      }
    };
  }, [isInOverlay, setAcsQueryParam]);
};
